import { render, staticRenderFns } from "./collect-node.vue?vue&type=template&id=67a23b6a&scoped=true&"
import script from "./collect-node.vue?vue&type=script&lang=js&"
export * from "./collect-node.vue?vue&type=script&lang=js&"
import style0 from "./collect-node.vue?vue&type=style&index=0&id=67a23b6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a23b6a",
  null
  
)

export default component.exports